import { DAYS } from "./constants";

export const WEEKDAYS: readonly string[] = DAYS;

export function getOrganizationServiceDays(organization?: { serviceScheduleDays?: string[] | null } | null): string[] {
  const configured = (organization?.serviceScheduleDays || []).filter((day) => WEEKDAYS.includes(day));
  return configured.length ? configured : WEEKDAYS.slice();
}

export function getMissingOrganizationServiceDays(
  locationCadenceDays: string[] = [],
  organizationDays: string[] = [],
): string[] {
  const allowed = new Set(getOrganizationServiceDays({ serviceScheduleDays: organizationDays }));
  return WEEKDAYS.filter((day) => locationCadenceDays.includes(day) && !allowed.has(day));
}

export function formatServiceDayList(days: string[]): string {
  if (days.length <= 1) return days[0] || "";
  if (days.length === 2) return `${days[0]} and ${days[1]}`;
  return `${days.slice(0, -1).join(", ")}, and ${days[days.length - 1]}`;
}
